/**
 * Browser auth client for the dashboard. Talks to `/api/auth/*` on the same
 * origin (the web Worker proxies it to the API Worker), so session cookies are
 * first-party, HttpOnly and never readable from JavaScript.
 */
import { passkeyClient } from "@better-auth/passkey/client";
import { emailOTPClient, organizationClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { ac, roles } from "./permissions.ts";

export function createNudgeboxAuthClient(baseURL?: string) {
  return createAuthClient({
    ...(baseURL ? { baseURL } : {}),
    basePath: "/api/auth",
    plugins: [organizationClient({ ac, roles }), emailOTPClient(), passkeyClient()],
  });
}

export type NudgeboxAuthClient = ReturnType<typeof createNudgeboxAuthClient>;
